import { render, staticRenderFns } from "./lanmao-load.vue?vue&type=template&id=656a1708&scoped=true&"
import script from "./lanmao-load.vue?vue&type=script&lang=js&"
export * from "./lanmao-load.vue?vue&type=script&lang=js&"
import style0 from "./lanmao-load.vue?vue&type=style&index=0&id=656a1708&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656a1708",
  null
  
)

export default component.exports